module.exports = __webpack_public_path__ + "83384971e99b6786d36ad787a3c228e8.png";